import createIcon from '../../createIcon';

/**
 * @component @name StarHalf
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgOS43NEwxNC44MSA5LjEyTDEyIDIuNUw5LjE5IDkuMTNMMiA5Ljc0TDcuNDYgMTQuNDdMNS44MiAyMS41TDEyIDE3Ljc3TDE4LjE4IDIxLjVMMTYuNTUgMTQuNDdMMjIgOS43NFpNMTIgMTUuOVY2LjZMMTMuNzEgMTAuNjRMMTguMDkgMTEuMDJMMTQuNzcgMTMuOUwxNS43NyAxOC4xOEwxMiAxNS45WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StarHalf = createIcon('StarHalf', [
  [
    'path',
    {
      d: 'M22 9.74L14.81 9.12L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77L18.18 21.5L16.55 14.47L22 9.74ZM12 15.9V6.6L13.71 10.64L18.09 11.02L14.77 13.9L15.77 18.18L12 15.9Z',
      key: '9ubd3t',
    },
  ],
]);

export default StarHalf;
